import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "#/libs/utils.ts"

const alertVariants = cva(
	"relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-lg border px-4 py-3 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5",
	{
		variants: {
			variant: {
				default: "border-border bg-card text-card-foreground",
				destructive:
					"border-destructive/40 bg-destructive/10 text-foreground [&>svg]:text-destructive",
				warning: "border-warning/40 bg-warning/10 text-foreground [&>svg]:text-warning",
				success: "border-success/40 bg-success/10 text-foreground [&>svg]:text-success",
			},
		},
		defaultVariants: { variant: "default" },
	},
)

function Alert({
	className,
	variant,
	...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
	return (
		<div
			data-slot="alert"
			role="alert"
			className={cn(alertVariants({ variant }), className)}
			{...props}
		/>
	)
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			data-slot="alert-title"
			className={cn("col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight", className)}
			{...props}
		/>
	)
}

function AlertDescription({ className, ...props }: React.ComponentProps<"div">) {
	return (
		<div
			data-slot="alert-description"
			className={cn(
				"col-start-2 grid justify-items-start gap-1 text-sm text-muted-foreground [&_p]:leading-relaxed",
				className,
			)}
			{...props}
		/>
	)
}

export { Alert, AlertDescription, AlertTitle }
